const initialCreateUserValue = {
	userId: '',
	userName: '',
	userRole: '',
	password: '',
	confirmPassword: '',
};

export default initialCreateUserValue;
